import Link from "next/link";
import styles from "./css/BlogHeader.module.css";
import {
  Body1,
  ButtonTheme,
  ButtonWithText,
  ColorClass,
  ColorValue,
  FontClass,
  Header1,
} from "ui";
import { useIsLoggedIn } from "@web/hooks/auth/useIsLoggedIn";
import { HarkenIcon } from "@web/components/icons/HarkenIcon";
import { isFromNative } from "@web/utils/env/isFromNative";

export function BlogHeader() {
  const isLoggedIn = useIsLoggedIn();
  const fromNative = isFromNative();
  return (
    <div className={styles.container}>
      <Link href="/blog" style={{ textDecoration: "none" }}>
        <div className={styles.left}>
          <div className={styles.iconAndText}>
            <HarkenIcon colorValue={ColorValue.HighlightHover} />
            <Header1 colorClass={ColorClass.HighlightHover}>Blog</Header1>
          </div>
          <Body1 colorClass={ColorClass.Secondary}>Updates from Harken</Body1>
        </div>
      </Link>
      <ButtonWithText
        buttonTheme={ButtonTheme.Highlight}
        fontClass={FontClass.Body1Medium}
        href={
          fromNative
            ? isLoggedIn
              ? "/decks"
              : "/native/login"
            : isLoggedIn
            ? "/decks"
            : "/login"
        }
        type="link_internal"
      >
        Go to App
      </ButtonWithText>
    </div>
  );
}
